import React from "react";
import ReactApexChart from 'react-apexcharts';
import {useNavigate} from "react-router-dom";
import {Datum} from "../models/BookResponseModel";
import {modifyChannelName} from "../../../utils/common";


interface BooksTableProps {
    data: Datum[];
    setPage: (value: number) => void;
    currentPage: number;
    totalPages: number;
    fromDate: string; // Add fromDate prop
    toDate: string; // Add toDate prop
}

const BooksTableDetails: React.FC<BooksTableProps> = ({
                                                          data,
                                                          setPage,
                                                          currentPage,
                                                          totalPages,
                                                      }) => {
    const navigate = useNavigate()
    const pieData :any= data?.map((row, index:number) => {
        return row.percentage
    })


    const options: {
        plotOptions: { pie: { donut: { size: string; background: string } } };
        dataLabels: {
          formatter: (value: any, { seriesIndex }: { seriesIndex: any }) => (string | any);
          style: { fontSize: string; colors: string[]; fontWeight: string };
          enabled: boolean;
        };
        legend: any;
        responsive: ({ options: { chart: { width: number; height: number } }; breakpoint: number } | {
          options: { chart: { width: number } };
          breakpoint: number;
        })[];
        chart: { type: "donut" }; // Explicitly type the chart property
        colors: string[];
        labels: string[];
      } = {
        chart: {
          type: 'donut',
        },
        colors: pieData < 0 ? ["#ff5612", "#DC3545"] : ["#25D228", "#ff5612"],
        labels: pieData < 0 ? ["Profit", "Loss"] : ["Profit", 'Revenue'],
        legend: {
          show: true,
          position: 'right',
        },
        plotOptions: {
          pie: {
            donut: {
              size: '35%',
              background: 'transparent',
            },
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ['#FFFFFF'],
            fontSize: '14px',
            fontWeight: 'bold',
          },
          formatter: function (value, { seriesIndex }) {
            if (seriesIndex === 1) {
              return '';
            }
            return `${value}%`;
          },
        },
        responsive: [
          {
            breakpoint: 2600,
            options: {
              chart: {
                width: 290,
                height: 250,
              },
            },
          },
          {
            breakpoint: 640,
            options: {
              chart: {
                width: 600,
              },
            },
          },
        ],
      };
      


    // const options: {
    //     plotOptions: { pie: { donut: { size: string; background: string } } };
    //     dataLabels: {
    //         formatter: (value: any, {seriesIndex}: { seriesIndex: any }) => (string | any);
    //         style: { fontSize: string; colors: string[]; fontWeight: string };
    //         enabled: boolean
    //     };
    //     legend: { show: boolean; position: string };
    //     responsive: ({ options: { chart: { width: number; height: number } }; breakpoint: number } | {
    //         options: { chart: { width: number } };
    //         breakpoint: number
    //     })[];
    //     chart: { type: string };
    //     colors: string[];
    //     labels: string[]
    // } = {
    //     chart: {
    //         type: 'donut',
    //     },
    //     colors: pieData < 0 ? ["#ff5612", "#DC3545"] : ["#25D228", "#ff5612"],
    //     labels: pieData < 0 ? ["Profit", "Loss"] : ["Profit", 'Revenue'],
    //     legend: {
    //         show: true,
    //         position: 'right',
    //     },
    //     plotOptions: {
    //         pie: {
    //             donut: {
    //                 size: '35%',
    //                 background: 'transparent',
    //             },
    //         },
    //     },
    //     dataLabels: {
    //         enabled: true,
    //         style: {
    //             colors: ['#FFFFFF'],
    //             fontSize: '14px',
    //             fontWeight: 'bold',
    //         },
    //         formatter: function (value, {seriesIndex}) {
    //             if (seriesIndex === 1) {
    //                 return '';
    //             }
    //             return `${value}%`;
    //         },
    //     },
    //     responsive: [
    //         {
    //             breakpoint: 2600,
    //             options: {
    //                 chart: {
    //                     width: 290,
    //                     height: 250,
    //                 },
    //             },
    //         },
    //         {
    //             breakpoint: 640,
    //             options: {
    //                 chart: {
    //                     width: 600,
    //                 },
    //             },
    //         },
    //     ],
    // };
    return (
        <div
            className="rounded-xl border border-stroke bg-white  shadow-default dark:border-strokedark dark-bg-boxdark">
            <div className="max-w-full overflow-x-auto ">
                <table className="w-full table-auto ">
                    <thead>
                    <tr className="border-b-2 border-[#DEDFE3]  text-left dark:bg-meta-4 ">
                        <th className="min-w-[50px] py-1 px-4  border-r border-[#DEDFE3] text-black  dark-text-white text-center font-semibold">
                            S.No
                        </th>
                        <th className="min-w-[220px] py-4 px-4 border-r border-[#DEDFE3]  text-black dark-text-white xl:pl-11 font-semibold">
                            Book Image
                        </th>
                        <th className="min-w-[140px] py-4 px-4 border-r border-[#DEDFE3]  text-black dark-text-white font-semibold">
                            Book Name
                            /Author name
                        </th>
                        <th className="min-w-[150px] py-4 px-4 border-r border-[#DEDFE3]  text-black dark-text-white text-center font-semibold">
                            Total Sales
                        </th>
                        <th className="min-w-[150px] py-4 px-4 border-r border-[#DEDFE3]  text-black dark-text-white text-center font-semibold">
                            Total Expenses
                        </th>
                        <th className="min-w-[150px] py-4 px-4 border-r border-[#DEDFE3]  text-black dark-text-white text-center font-semibold">
                            Profit & Loss
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {data?.map((row, index) => (
                        <>
                            <tr key={index}>
                                <td className="border border-[#eee] dark-border-strokedark ">
                                    <p className=" text-sm  text-center text-black font-semibold">
                                        {row.id}
                                    </p>
                                </td>
                                <td className="border border-[#eee] py-3 px-3 dark-border-strokedark" onClick={() => {
                                    navigate(`/all-books/detail-view/${row.id}`)
                                }
                                }>
                                    <div className="flex items-center justify-center cursor-pointer">
                                        <div className="w-36">
                                            <img src={`images/books/${row.id}.png`} alt=""/>
                                        </div>
                                    </div>
                                </td>

                                <td className="border border-[#eee] py-3 px-3 dark-border-strokedark">
                                    <div className="flex flex-col items-center">
                                        <p className="text-black font-Poppins text-18 font-medium leading-24 whitespace-nowrap">
                                            {row.name}
                                        </p>

                                        <p className="flex items-center justify-center">
                                            by
                                        </p>
                                        <div className="flex gap-4 items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20"
                                                 viewBox="0 0 21 20" fill="none">
                                                <path
                                                    d="M7.45077 0.0147841C7.43126 0.0258813 6.02377 0.0346141 3.9591 0.0346141H0.5L0.515217 4.71143C0.52381 7.28333 0.532582 9.41897 0.536879 9.45427C0.543324 9.51375 0.586827 9.46081 0.968505 8.94741C1.20267 8.63449 1.61693 8.07688 1.8903 7.71103C2.44329 6.97059 3.89213 5.00013 4.68575 3.90475C4.81806 3.72409 5.04147 3.41773 5.18236 3.22161C5.3256 3.02768 5.53378 2.73678 5.6464 2.58033C5.75917 2.42168 5.88271 2.26304 5.91958 2.22556C5.95646 2.18809 6.03667 2.08895 6.09521 2.00525C6.34674 1.6505 6.58538 1.31756 6.64391 1.23606C6.78266 1.04431 7.4225 0.151776 7.46796 0.0855545C7.51809 0.0147841 7.50716 -0.0226933 7.45077 0.0147841Z"
                                                    fill="black"/>
                                                <path
                                                    d="M20.4195 0.0496947C20.4083 0.0755197 20.2084 0.351766 19.9796 0.660255C19.6765 1.06811 19.3328 1.48668 18.7134 2.20302C18.2463 2.74021 17.7187 3.35307 17.5391 3.56022C17.3617 3.76735 17.1418 4.01973 17.0542 4.12125C16.9665 4.22279 16.7938 4.42119 16.6702 4.5635C16.5467 4.70599 16.2907 5.00147 16.0998 5.22161C15.642 5.75024 15.5947 5.80421 14.5955 6.95853C13.5853 8.12799 13.7289 7.96395 13.383 8.35882C13.2282 8.53354 13.0486 8.74282 12.9814 8.8228C12.9163 8.90045 12.8196 9.01266 12.7657 9.07303C12.714 9.13127 12.5906 9.27376 12.4941 9.38812C12.3369 9.57371 12.0472 9.90587 11.9149 10.0548C11.8452 10.1346 11.7038 10.2986 11.3289 10.7344C10.9405 11.1854 10.4532 11.7486 10.332 11.8888C10.2849 11.9428 9.97063 12.3115 9.63146 12.7086C9.29249 13.1056 8.92203 13.5372 8.80972 13.6688C8.69741 13.7983 8.32934 14.232 7.99464 14.6289C7.6579 15.026 7.34579 15.3949 7.30094 15.4466C7.01572 15.779 6.72402 16.1242 6.23455 16.7109C6.07517 16.9008 5.89781 17.1102 5.83944 17.1749C5.72713 17.3024 5.19281 17.9388 4.14885 19.1925L3.5 19.9691L4.42944 19.9821C4.93909 19.9886 6.21213 19.9973 7.25609 19.9994C9.0903 20.0016 9.15777 19.9994 9.18686 19.9606C9.20483 19.939 9.43149 19.6911 9.68985 19.4083C9.95024 19.1257 10.3118 18.7287 10.4958 18.5258C10.6777 18.3229 10.9 18.0835 10.9898 17.995C11.1402 17.8418 11.2794 17.6845 12.2133 16.5926C12.431 16.3401 12.6601 16.0725 12.7207 15.9993C12.7836 15.928 13.0215 15.6521 13.2484 15.3843C13.4752 15.1168 13.7624 14.7823 13.8883 14.64C14.0118 14.4976 14.2429 14.2278 14.4024 14.038C14.5618 13.8502 14.9613 13.382 15.2892 13.0002C16.1963 11.9472 17.3099 10.6461 17.4355 10.4993C17.4961 10.4259 17.853 10.0074 18.2301 9.56943C18.6074 9.12931 19.0273 8.63953 19.162 8.47975C19.2988 8.32018 19.5166 8.06548 19.6469 7.91658C19.7772 7.76768 20.0082 7.49801 20.1632 7.31884C20.316 7.13753 20.4551 6.99095 20.4709 6.99095C20.4934 6.99095 20.5 6.72556 20.5 5.67901C20.5 3.70465 20.4709 0 20.4574 0C20.4508 0 20.4328 0.0215523 20.4195 0.0496947Z"
                                                    fill="black"/>
                                                <path
                                                    d="M11.4549 0.0035479L11.1966 0.0121144L10.7859 0.491999C9.72724 1.72431 9.52818 1.95345 9.40321 2.08533C9.27404 2.21936 9.07078 2.46796 8.46726 3.22036C8.31486 3.41062 8.02893 3.76522 7.83212 4.00952C7.63516 4.25385 7.31759 4.64736 7.12707 4.88508C6.93446 5.12296 6.68034 5.4385 6.55957 5.5877C6.4388 5.73689 6.32885 5.87305 6.314 5.89037C6.26733 5.95087 5.89051 6.41791 5.0521 7.45781C4.59261 8.02854 4.15444 8.5734 4.07807 8.66851C4.00395 8.76365 3.92985 8.85448 3.91499 8.86965C3.88109 8.90641 3.45969 9.42753 3.33491 9.58743C3.24175 9.71075 3.13583 9.83818 2.54299 10.5711C2.37781 10.7722 2.10674 11.1094 1.94174 11.3169C1.77448 11.5245 1.61351 11.7256 1.58187 11.7624C1.55216 11.7991 1.33212 12.0715 1.09285 12.3677C0.853577 12.664 0.62287 12.9405 0.580398 12.984L0.5 13.0618V14.3569C0.5 17.0441 0.52744 20.0408 0.550861 19.9996C0.563619 19.978 0.760419 19.6948 0.987108 19.3683C1.35764 18.8386 1.63921 18.4776 2.57305 17.3382C2.67041 17.2194 2.88432 16.9578 3.04948 16.7545C3.40726 16.3136 4.38131 15.1201 5.59444 13.6306C6.31435 12.7462 8.31731 10.2902 9.32735 9.04723C9.8842 8.36406 11.432 6.44414 11.9443 5.80203C12.0268 5.70048 12.425 5.19882 12.8315 4.68859C13.238 4.17836 13.672 3.63351 13.7969 3.48003C14.2797 2.87683 16.4394 0.139715 16.4986 0.0554806C16.5199 0.0251419 16.3208 0.0208592 14.4449 0.0144339C13.3036 0.0122925 12.2196 0.00586736 12.0396 0.00140655C11.8594 -0.000734794 11.5946 -0.000734794 11.4549 0.0035479Z"
                                                    fill="black"/>
                                                <path
                                                    d="M20.1603 10.9235C19.9979 11.1429 19.7275 11.5051 19.5608 11.729C18.8662 12.6509 16.8799 15.3461 16.1291 16.3845C16.023 16.5338 15.8024 16.8343 15.6421 17.0539C15.4821 17.2732 15.3025 17.5235 15.2418 17.607C15.1835 17.6926 15.1184 17.765 15.099 17.7716C15.0817 17.776 15.0102 17.8594 14.9432 17.9538C14.8783 18.0481 14.7292 18.2545 14.6145 18.4125C14.4998 18.5683 14.3678 18.7528 14.3224 18.8186C14.2771 18.8842 14.0714 19.1697 13.8702 19.4506C13.6667 19.7315 13.5 19.9709 13.5 19.9839C13.5 19.997 14.8244 20.0015 17.0011 19.9993L20.5 19.9928L20.4914 16.8321C20.4871 15.0938 20.4762 12.9647 20.4698 12.0977L20.4567 10.5262L20.1603 10.9235Z"
                                                    fill="black"/>
                                                <path
                                                    d="M0.5 0.0411455L2.84168 2.09327L5.91918 2.10526L7.5 0L0.5 0.0411455Z"
                                                    fill="#646464"/>
                                                <path d="M0.5 0V9.47369L2.5 2.17076L0.5 0Z" fill="#0F0F0F"/>
                                                <path d="M2.66056 2.10504L5.5 2.11784L0.5 9.47346L2.66056 2.10504Z"
                                                      fill="black"/>
                                                <path
                                                    d="M9.50049 2.09289L11.2964 0H16.5005L12.1197 2.10526L9.50049 2.09289Z"
                                                    fill="#646464"/>
                                                <path
                                                    d="M9.70416 2.10504L12.5 2.11835L3.35994 13.6479L0.5 13.684L9.70416 2.10504Z"
                                                    fill="#4F4F4F"/>
                                                <path d="M0.532299 13.7145L3.5 13.6842L0.5 20L0.532299 13.7145Z"
                                                      fill="#0F0F0F"/>
                                                <path d="M3.26867 12.9459L12.0218 2.1252L16.5 0L0.5 20L3.26867 12.9459Z"
                                                      fill="black"/>
                                                <path d="M3.5 20L8.36959 17.6544L17.7205 6.90693L20.5 0L3.5 20Z"
                                                      fill="#4F4F4F"/>
                                                <path
                                                    d="M8.56596 17.8947L11.5 18.0516L9.43187 19.992L3.5 19.9999L8.56596 17.8947Z"
                                                    fill="#0F0F0F"/>
                                                <path d="M20.4547 0L17.5 6.31579H20.5L20.4547 0Z" fill="#0F0F0F"/>
                                                <path d="M17.718 6.3158H20.5L11.2802 17.8947L8.5 17.7095L17.718 6.3158Z"
                                                      fill="black"/>
                                                <path d="M15.5 17.8946H18.2898L20.5 10.5262L15.5 17.8946Z"
                                                      fill="#4F4F4F"/>
                                                <path
                                                    d="M15.1844 17.8947H18.1261L20.5 19.9999L13.5 19.9916L15.1844 17.8947Z"
                                                    fill="#0F0F0F"/>
                                                <path d="M20.4458 10.5262L20.5 19.9999L17.5 17.6898L20.4458 10.5262Z"
                                                      fill="black"/>
                                            </svg>
                                            <p className="text-black font-Poppins text-16 font-medium leading-24">
                                                Zebralearn
                                            </p>
                                        </div>
                                    </div>
                                </td>

                                <td className='border border-[#eee] px-3 py-3 dark-border-strokedark  flex flex-col gap-y-3 group '>
                                    {row.product_items.map((item, index) => (
                                        <div
                                            key={index}
                                            className='bg-white p-2 rounded-lg shadow-md  flex group'
                                        >
                                            <div className='flex gap-x-4 '>
                                                <div className='flex items-center gap-x-2'>
                                                    <img src={`icons/${item.channel.id}.png`} alt=""/>
                                                    <p className='text-lg font-semibold w-28 break-words text-black whitespace-nowrap'>
                                                        {/*{item.channel.name === "Woo-commerce" ? "ZebraLearn" : item.channel.name}*/}
                                                        {modifyChannelName(item.channel.name, index)}

                                                    </p>
                                                </div>
                                                <div className='mt-2 '>
                                                    <p className='text-gray-600 '>
                                                        <b className="text-black">Quantity </b>: {item?.datedSales[0]?.total_quantity ? item.datedSales[0].total_quantity : 0}
                                                    </p>
                                                    <p className='text-gray-600'><b className="text-black">Amount </b>:
                                                        ₹{(item?.datedSales[0]?.total_amount ? Math.round(item.datedSales[0].total_amount) : 0).toLocaleString('en-IN')}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </td>
                                <td className="border border-[#eee] py-4 px-4 dark-border-strokedark">
                                    {row?.marketing_expenses.map((item) => (
                                        <div className="py-1">
                                            <div
                                                className="rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark flex flex-row gap-10 p-1 items-center">
                                                <div className="flex gap-4">
                                                    <p className="text-black font-Poppins text-18 font-medium leading-24">
                                                        {item?.channel_name}
                                                    </p>
                                                    <p className="text-black font-Poppins text-18 font-medium leading-24">
                                                        ₹{Math.round(item.total_amount_spent).toLocaleString('en-IN')}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <div className="flex flex-col gap-2">
                                        <div
                                            className="rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark flex flex-row gap-10 p-2  items-center">
                                            <div className="flex gap-4">
                                                <p className="text-black font-Poppins text-18 font-medium leading-24">
                                                    Royalty
                                                </p>
                                                <p className="text-black font-Poppins text-18 font-medium leading-24">
                                                    <span
                                                        className="text-[#9F9F9F]">₹</span> {Math.round(row.total_author_royalty_amount).toLocaleString('en-IN')}
                                                </p>
                                            </div>
                                        </div>
                                        <div
                                            className="rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark flex flex-row gap-10 p-2 items-center">
                                            <div className="flex gap-4">
                                                <p className="text-black font-Poppins text-18 font-medium leading-24">
                                                    COGS
                                                </p>
                                                <p className="text-black font-Poppins text-18 font-medium leading-24">
                                                    <span
                                                        className="text-[#9F9F9F]">₹ </span>{Math.round(row?.cogs).toLocaleString('en-IN')}
                                                </p>
                                            </div>
                                        </div>

                                        <div className="flex justify-center">
                                            <a href="*" className="cursor-pointer">& more expenses</a>
                                        </div>
                                    </div>
                                </td>
                                <td className="border border-[#eee] py-4 px-4 dark-border-strokedark ">
                                    <div className="flex flex-col">
                                        <div id="chartThree" className="mx-auto flex justify-center">
                                            <ReactApexChart
                                                options={options}
                                                series={[Math.abs(Math.round(row.percentage)), 100 - Math.abs(Math.round(row.percentage))]}
                                                type="donut"
                                            />
                                        </div>

                                        <div
                                            className="rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-2">
                                            <div className="flex flex-col gap-2">
                                                <div className="flex justify-between">
                                                    <div className="flex gap-3">
                                                        <p className="text-black font-Poppins text-18 font-medium leading-24">
                                                            Profit
                                                        </p>
                                                        <p className="text-grey font-Poppins text-18 font-medium leading-24">
                                                            ( {Math.round(row?.percentage)}%)
                                                        </p>

                                                    </div>
                                                    <div className="flex gap-2">
                                                        <p className="text-grey font-Poppins text-18 font-medium leading-24">
                                                            ₹
                                                        </p>
                                                        <p className="text-black font-Poppins text-18 font-medium leading-24">
                                                            {Math.round(row?.profitOrLoss).toLocaleString('en-IN')}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex justify-between ">
                                                    <div className="flex gap-2">
                                                        <p className="text-black font-Poppins text-18 font-medium leading-24">
                                                            Total Revenue amount :
                                                        </p>
                                                    </div>
                                                    <div className="flex gap-2">
                                                        <p className="text-grey font-Poppins text-18 font-medium leading-24">
                                                            ₹
                                                        </p>
                                                        <p className="text-black font-Poppins text-18 font-medium leading-24">
                                                            {Math.round(row?.totalSales).toLocaleString('en-IN')}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="flex justify-between">
                                                    <div className="flex gap-2">
                                                        <p className="text-black font-Poppins text-18 font-medium leading-24">
                                                            Total Expense amount : </p>
                                                    </div>
                                                    <div className="flex gap-2">
                                                        <p className="text-grey font-Poppins text-18 font-medium leading-24">
                                                            ₹
                                                        </p>
                                                        <p className="text-black font-Poppins text-18 font-medium leading-24">
                                                            {Math.round(row?.totalExpenses).toLocaleString('en-IN')}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </td>

                            </tr>
                        </>
                    ))}
                    </tbody>
                </table>
            </div>
            <div className="flex justify-end gap-x-2 pb-2 mt-4">
                <button
                    className="text-sm bg-meta-5 p-2 text-white rounded-md disabled:cursor-not-allowed disabled:bg-body hover:text-blue-700 cursor-pointer"
                    disabled={currentPage === 1}
                    onClick={() => currentPage > 1 && setPage(currentPage - 1)}
                >
                    Previous Page
                </button>
                <button
                    className="text-sm bg-meta-5 p-2 text-white rounded-md disabled:cursor-not-allowed disabled:bg-body hover:text-blue-700 cursor-pointer"
                    disabled={currentPage === totalPages}
                    onClick={() =>
                        currentPage !== totalPages && setPage(currentPage + 1)
                    }
                >
                    Next Page
                </button>
            </div>
        </div>

    );
};

export default BooksTableDetails;
